module.exports = __webpack_public_path__ + "static/media/promo-img-1.7c098ce6.png";